import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = BASE ? `${BASE}/api` : null;
export const mediaUrl = (path) => (path && BASE ? `${BASE}/api/media/${path}` : "");
export const assetUrl = (path) => (!path ? "" : path.startsWith("/") ? path : mediaUrl(path));
export const posterFor = (path) => (path?.startsWith("/media/") ? path.replace(/\.mp4$/, ".jpg") : undefined);

export const http = axios.create({ baseURL: API || "/api", timeout: 20000 });

export function apiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(" ");
  return detail?.msg || "Something went wrong.";
}

export const PKG_KEY = "rivanta_package";
export const getSelectedPackage = () => {
  try { return localStorage.getItem(PKG_KEY) || ""; } catch { return ""; }
};
export const setSelectedPackage = (id) => {
  try { localStorage.setItem(PKG_KEY, id); } catch { /* storage unavailable */ }
  window.dispatchEvent(new CustomEvent("rivanta:package", { detail: id }));
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return false;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
  return true;
};
